module.exports = __webpack_public_path__ + "pisek0-4-betonak.jpg?0c06dd25032b38c905a6276fbf1d6b62";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pisek0-4-betonak.jpg
// module id = 70
// module chunks = 0